import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useBrandList(params) {
  return useSWR(
    {
      path: `/api/v1/brands`,
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useBrandList;
